import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "app-notifications" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Generate Template ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Generate an Excel Import Template ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Welcome to Photon!", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-center pt-2" }, "Data export/import service for Nova", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Logout")

import AppNotification from '@/components/AppNotification.vue';
import { useStore } from 'vuex';
import { successRes } from '@/services/util';
import { useRouting } from '@/composables/router';
import { exportWorkbook, IExportedData } from '@/services/workbookService';
import { useRoute } from 'vue-router';
import { NovaUserRoles } from '@/enums/nova/novaEnums';

enum templateTypes {
  USERS = 'users',
  CARRIERS = 'carriers',
  ALLUSERS = 'users-carriers'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const { routeLoggedIn, routeLoggedOut } = useRouting();
const route = useRoute();

const IMPORT_TEMPLATES = {
  [templateTypes.USERS]: {
    label: 'Users',
    type: templateTypes.USERS
  },
  [templateTypes.CARRIERS]: {
    label: 'Carriers',
    type: templateTypes.CARRIERS
  },
  [templateTypes.ALLUSERS]: {
    label: 'Users and Carriers',
    type: templateTypes.ALLUSERS
  }
};

const handleInitialToken = async () => {
  if (route.query?.token) {
    await store.dispatch('login', route.query.token);
  }

  await store.dispatch('setInitialAccessToken');

  try {
    const response = await store.dispatch('getMe');
    if (successRes(response.status) && response.data?.role === NovaUserRoles.INTERNAL) {
      await routeLoggedIn();
    } else {
      await routeLoggedOut();
    }
  } catch (e) {
    await routeLoggedOut();
  }
};

const logout = async () => {
  await store.dispatch('logout');
  await routeLoggedOut();
};

handleInitialToken();

const generateImportTemplate = (type: templateTypes) => {
  switch (type) {
    case templateTypes.USERS: {
      exportWorkbook(
        buildUsersTemplate() as Partial<IExportedData>,
        `${IMPORT_TEMPLATES[templateTypes.USERS].label} Import Template`,
        ''
      );
      break;
    }
    case templateTypes.CARRIERS: {
      exportWorkbook(
        buildCarriersTemplate() as Partial<IExportedData>,
        `${IMPORT_TEMPLATES[templateTypes.CARRIERS].label} Import Template`,
        ''
      );
      break;
    }
    case templateTypes.ALLUSERS: {
      exportWorkbook(
        { ...buildUsersTemplate(), ...buildCarriersTemplate() } as Partial<IExportedData>,
        `${IMPORT_TEMPLATES[templateTypes.ALLUSERS].label} Import Template`,
        ''
      );
      break;
    }
    default: {
      break;
    }
  }
};

function buildUsersTemplate() {
  return {
    users: [
      {
        firstName: 'User',
        lastName: 'Name',
        email: 'useremail@test.com',
        role: 'role_admin',
        warehouseAccessList: 'Warehouse Name 1; Warehouse Name 2'
      }
    ]
  };
}

function buildCarriersTemplate() {
  return {
    carriers: [
      {
        firstName: 'Carrier',
        lastName: 'Name',
        email: 'carrieremail@test.com',
        phone: '5555555555',
        company: 'Company Name'
      }
    ]
  };
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_banner = _resolveComponent("v-banner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AppNotification, {
          width: "480",
          class: "mb-2",
          max: 5,
          position: "bottom center",
          duration: 5000
        })
      ]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (!_ctx.$route.meta.shouldHideBanner)
            ? (_openBlock(), _createBlock(_component_v_banner, {
                key: 0,
                class: "d-flex flex-column site-banner is-relative"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_menu, null, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        size: "small",
                        id: "template-generator-button",
                        color: "primary"
                      }, props), {
                        default: _withCtx(() => [
                          _hoisted_2,
                          _createVNode(_component_v_tooltip, {
                            location: "bottom",
                            activator: "parent"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(IMPORT_TEMPLATES, (item, index) => {
                            return _createVNode(_component_v_list_item, {
                              key: index,
                              value: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  size: "small",
                                  class: "text-left justify-start",
                                  plain: "",
                                  block: "",
                                  onClick: ($event: any) => (generateImportTemplate(item.type))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          }), 64))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_4,
                  _hoisted_5,
                  (_unref(store).state.me)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "text",
                        onClick: logout,
                        id: "logout-btn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_container, {
            fluid: _ctx.$route.meta.isFullScreen,
            class: _normalizeClass({ 'ma-0 pa-0': _ctx.$route.meta.isFullScreen })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }, 8, ["fluid", "class"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})